/**
 * Infinite Scroll
 */
var loadMore = document.getElementById('smc_load_more');
var loadMoreSection = document.getElementById('smc_load_more_section');

(function(window, document) {
    // next link element
    var nextElement = document.querySelector('link[rel=next]');
    if (!nextElement) return;

    // post feed element
    var feedElement = document.getElementById('smc_load_more_target');
    if (!feedElement) return;

    var ticking = false;
    var loading = false;

    function onPageLoad() {
        if (this.status === 404) {
            console.log('status 404');
            return;
        }

        // append contents
        var postElements = this.response.querySelectorAll('#smc_load_more_target .smc-loop-item');
        postElements.forEach(function (item) {
            feedElement.appendChild(item);
        });

        // safari fix: parse images again
        postElements.forEach(function (item) {
            var image = item.querySelector('img');
            if (image) {
              image.outerHTML = image.outerHTML;
              // console.log(image.outerHTML);
            }
        });

        // set next link
        var resNextElement = this.response.querySelector('link[rel=next]');
        if (resNextElement) {
            nextElement.href = resNextElement.href;
        }

        // sync status
        ticking = false;
        loading = false;
    }

    function onUpdate() {
        // return if already loading
        if (loading) return;

        loading = true;

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = 'document';

        xhr.addEventListener('load', onPageLoad);

        xhr.open('GET', nextElement.href);
        xhr.send(null);
    }

    function requestTick() {
        ticking || window.requestAnimationFrame(onUpdate);
        ticking = true;
    }

    if (loadMore) {
            loadMore.addEventListener('click', function() {

                requestTick();
                numberPage = numberPage - 1;
                 if (numberPage < 2) {
                    loadMoreSection.parentNode.removeChild(loadMoreSection);
                    // console.log('less than 2 pages');
                }

            }, false);
    }

})(window, document);

if (typeof numberPage !== 'undefined' && numberPage < 2 && loadMoreSection !== null) {
    loadMoreSection.parentNode.removeChild(loadMoreSection);
    // console.log('less than 2 pages');
}
